<template>
  <div class="keyboard-error-window">
    <div class="keyboard-error-window-text">
      <h3>
        Oops, something went wrong! Please get your teacher!
        <br /><br />
        We have detected a key input error which can be caused by an incompatible keyboard. Please
        make sure that your keyboarding input on the device is set to English (US).
        <br /><br />
        You can do this by going to your device settings under Settings/Device/Keyboard/Change Input
        Settings.
        <br /><br />
        If the issue persists, try reloading the activity.
      </h3>
      <button @click.stop.prevent="relogin">Reload</button>
    </div>
    <a
      @click="closeModal"
      v-html="buttonClose"
      aria-label="Close modal"
      class="modal-close-button progress keyboard-error"
      role="button"
    ></a>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import btnClose from 'assets/svg/btn-close.svg';

export default {
  data() {
    return {
      buttonClose: btnClose
    };
  },
  methods: {
    ...mapMutations('application', ['setModal']),
    closeModal() {
      this.setModal(undefined);
    },
    relogin() {
      window.location.reload();
    }
  }
};
</script>

<style lang="scss">
.keyboard-error-window {
  background-color: white;
  border-radius: 8px;
  height: 404px;
  margin: 0 auto;
  position: relative;
  width: 700px;
}
.keyboard-error-window-text {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  margin: auto;
  padding: 0px !important;
  width: 500px;
  button {
    background-color: green;
    border: none;
    border-radius: 5px;
    color: white;
    font-family: 'hwtfutura-bold';
    font-size: 20px;
    line-height: 30px;
    max-width: 156px;
    margin-top: 16px;
    padding: 10px 20px;
    text-transform: uppercase;
  }
  h3 {
    color: black;
    font-family: 'hwtfutura-bold';
    font-size: 16px;
  }
}
.keyboard-error {
  right: -32px !important;
  top: -32px !important;
}
</style>
